import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { BRAND, CORRIDORS } from "@/config/brand";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-line bg-white pb-28 pt-14 md:pb-12">
    <div className="mx-auto max-w-[1280px] px-5 lg:px-8">
      <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <span className="font-display text-xl font-extrabold tracking-[-0.03em] text-ink">
            brickspace<span className="text-brand">.</span>
          </span>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-body">
            {BRAND.tagline} for the NH-24 / Delhi–Meerut Expressway corridor, Ghaziabad.
          </p>
          <a
            href={BRAND.url}
            data-testid="footer-website-link"
            className="mt-3 inline-block text-sm font-semibold text-brand hover:text-brandDark"
          >
            {BRAND.domain}
          </a>
        </div>

        <div>
          <h4 className="text-sm font-bold text-ink">Locations</h4>
          <ul className="mt-4 space-y-2.5">
            {CORRIDORS.filter((c) => c.key !== "other").map((c) => (
              <li key={c.key}>
                <a href="#corridors" className="text-sm text-body transition-colors hover:text-brand">
                  {c.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold text-ink">Contact</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-body">
            <li>
              <a href={`tel:${BRAND.phone}`} data-testid="footer-call-link" className="flex items-center gap-2 hover:text-brand">
                <Phone className="h-3.5 w-3.5 text-brand" /> {BRAND.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={`mailto:${BRAND.email}`} className="flex items-center gap-2 hover:text-brand">
                <Mail className="h-3.5 w-3.5 text-brand" /> {BRAND.email}
              </a>
            </li>
            <li className="flex gap-2">
              <MapPin className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand" /> {BRAND.address}
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold text-ink">Team</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-body">
            <li>
              <Link to="/crm/login" data-testid="footer-crm-login" className="hover:text-brand">
                Advisor / Owner login
              </Link>
            </li>
            <li>Mon – Sun · 9:30 AM – 8:00 PM</li>
          </ul>
        </div>
      </div>

      <div className="mt-12 border-t border-line pt-7">
        <p className="max-w-4xl text-xs leading-relaxed text-muted2">
          <span className="font-semibold text-body">Disclaimer:</span> BRICKSPACE is a real estate
          consultancy and advisory firm and is not a builder, developer or promoter. We do not
          construct or own any of the projects referenced on this website. All project names,
          specifications, prices and availability belong to their respective RERA-registered
          developers and are indicative, subject to change without notice. Prospective buyers are
          advised to independently verify RERA registration details on the UP RERA portal before
          making any purchase decision. This website does not constitute an offer or contract.
        </p>
        <p className="mt-5 text-xs text-muted2">
          © {new Date().getFullYear()} BRICKSPACE Consultancy. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);
